import { makeStyles } from '@material-ui/core';

import { VARIANT } from '../../shared/consts';

import { neutral } from 'shared/styles/colors';

import type { SaturationStateProp } from '../../shared/models';

export default makeStyles({
  container: {
    height: 'stretch',
    padding: '0.25rem 0.5rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${neutral[20]}`,
    borderRadius: '0.5rem',
    cursor: 'pointer',
    '@media (width >= 960px)': {
      flexDirection: 'row',
      gap: '0.5rem',
    },
  },
  btn: ({ variant }: SaturationStateProp) => ({
    padding: '0 0.5rem',
    fontWeight: 600,
    fontSize: '0.75rem',
    lineHeight: '1rem',
    boxShadow: 'none',
    borderRadius: '0.5rem',
    color: VARIANT[variant].color,
    backgroundColor: VARIANT[variant].bgColor,
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: `${VARIANT[variant].bgColor}9B`,
    },
    '&:disabled': {
      color: VARIANT.deactivated.color,
      backgroundColor: VARIANT[variant].bgColor,
    },
    '@media (width >= 960px)': {
      padding: '0.25rem 0.5rem',
      lineHeight: '1.25rem',
    },
  }),
  arrowIcon: {
    display: 'none',
    width: '0.5rem',
    height: '1.25rem',
    '@media (width >= 960px)': {
      display: 'block',
    },
  },
});
